module.exports = __webpack_public_path__ + "static/media/salvation_cover.b8902c5a.jpg";